<template>
  <span>Exit...</span>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Logout",

  mounted() {
    this.$auth.logout();
    this.$cookies.remove("is_login_in");
    this.$cookies.remove("token_exp");
    this.$cookies.remove("refresh_token");
    this.resetState();
    this.removeProfile();
    this.$router.push("/login");
  },

  methods: {
    ...mapActions({
      resetState: "resetState",
      removeProfile: "profile/removeProfile"
    })
  }
};
</script>

<style scoped>

</style>